export { SupportedLocales, localeToBookingLangCode, locales } from '@bookingcom/lingojs-locales';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes[ErrorCodes["NotUsingTFunction"] = 0] = "NotUsingTFunction";
    ErrorCodes[ErrorCodes["MissingPluralException"] = 1] = "MissingPluralException";
    ErrorCodes[ErrorCodes["MissingListItem"] = 2] = "MissingListItem";
    ErrorCodes[ErrorCodes["MissingVariable"] = 3] = "MissingVariable";
    ErrorCodes[ErrorCodes["MissingTag"] = 4] = "MissingTag";
    ErrorCodes[ErrorCodes["MissingNumExceptionArgument"] = 5] = "MissingNumExceptionArgument";
    ErrorCodes[ErrorCodes["MissingListItemArgument"] = 6] = "MissingListItemArgument";
    ErrorCodes[ErrorCodes["CallingListAsTag"] = 7] = "CallingListAsTag";
})(ErrorCodes || (ErrorCodes = {}));
var RuntimeError = /** @class */ (function (_super) {
    __extends(RuntimeError, _super);
    function RuntimeError(code) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _this = _super.call(this) || this;
        _this.code = code;
        _this.args = args;
        _this.message = getErrorMessage(code, args);
        return _this;
    }
    return RuntimeError;
}(Error));
function getErrorMessage(code, args) {
    switch (code) {
        case ErrorCodes.NotUsingTFunction: {
            var _a = __read(args, 1), tagName = _a[0];
            return "Unable to translate message ".concat(tagName, ". Did you forget to call `t` method from @bookingcom/lingojs-core?'");
        }
        case ErrorCodes.MissingPluralException: {
            var _b = __read(args, 2), tagName = _b[0], argName = _b[1];
            return "Missing plural exception `".concat(argName, "` for message `").concat(tagName, "`. Using fallback renderer instead.");
        }
        case ErrorCodes.MissingListItem: {
            var _c = __read(args, 2), tagName = _c[0], argName = _c[1];
            return "List item `".concat(argName, "`, for message `").concat(tagName, "`, does not exist in the dictionary. Using fallback renderer instead. Please, refer to op-doc TRANSLATIONS-01 for detailed follow-up instructions.");
        }
        case ErrorCodes.MissingVariable: {
            var _d = __read(args, 2), tagName = _d[0], argName = _d[1];
            return "Missing variable `".concat(argName, "` for message `").concat(tagName, "`. Using fallback renderer instead. Please, refer to op-doc TRANSLATIONS-01 for detailed follow-up instructions.");
        }
        case ErrorCodes.MissingTag: {
            var _e = __read(args, 1), tagName = _e[0];
            return "Missing translation for `".concat(tagName, "`. Using fallback renderer instead. Please, refer to op-doc TRANSLATIONS-01 for detailed follow-up instructions.");
        }
        case ErrorCodes.MissingNumExceptionArgument: {
            var _f = __read(args, 1), tagName = _f[0];
            return "Missing plural exception argument (`num_exception`) for `".concat(tagName, "`. Using fallback renderer instead. Please, refer to op-doc TRANSLATIONS-01 for detailed follow-up instructions.");
        }
        case ErrorCodes.MissingListItemArgument: {
            var _g = __read(args, 1), tagName = _g[0];
            return "Missing list item argument (`item`) for `".concat(tagName, "`. Using fallback renderer instead.");
        }
        case ErrorCodes.CallingListAsTag: {
            var _h = __read(args, 1), tagName = _h[0];
            return "Trying to translate a 'list' as 'tag' in `".concat(tagName, "`. Did you mean to use a list instead?");
        }
        default:
            return String(code);
    }
}

var TranslationMessage = /** @class */ (function () {
    function TranslationMessage(tag, args) {
        this.tag = tag;
        this.args = args;
    }
    return TranslationMessage;
}());
// tslint:disable-next-line:variable-name
function parseListArgs(list, item, form, num_exception, variables) {
    return new TranslationMessage("".concat(list, "/").concat(form), {
        variables: Object.assign({}, variables, { item: item }),
        num_exception: num_exception,
    });
}
function parseTagArgs(tag, num_exception, variables) {
    if (process.env.NODE_ENV !== 'production') {
        if (tag.indexOf('/') >= 0) {
            throw new RuntimeError(ErrorCodes.CallingListAsTag, tag);
        }
    }
    return new TranslationMessage(tag, {
        variables: variables,
        num_exception: num_exception,
    });
}
function parseTransArguments() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length >= 3) {
        var _a = __read(args, 4), list = _a[0], item = _a[1], form = _a[2], _b = _a[3], _c = _b === void 0 ? {} : _b, _d = _c.num_exception, num_exception_1 = _d === void 0 ? undefined : _d, _e = _c.variables, variables_1 = _e === void 0 ? {} : _e;
        return parseListArgs(list, item, form, num_exception_1, variables_1);
    }
    var _f = __read(args, 2), tag = _f[0], _g = _f[1], _h = _g === void 0 ? {} : _g, _j = _h.num_exception, num_exception = _j === void 0 ? undefined : _j, _k = _h.variables, variables = _k === void 0 ? {} : _k;
    return parseTagArgs(tag, num_exception, variables);
}

// This type schecking is arguably a little too laxed but we faced scenarios where this is needed
// https://booking.slack.com/archives/C05M8T6HBCJ/p1729678472438319?thread_ts=1729601700.194599&cid=C05M8T6HBCJ
function isTranslationMessage(obj) {
    return obj && obj instanceof TranslationMessage;
}
var IS_PROD = process.env.NODE_ENV === 'production';
var SELECT_ARG_NAME = 'item';
var PLURAL_ARG_NAME = 'num_exception';
var defaultFallbackRenderer = function () { return '💢'; };
var defaultOnTranslateFn = function (tag) { return tag; };
var defaultOnTranslateErrorFn = function (errorMessage) {
    if (!IS_PROD) {
        console.warn(errorMessage);
    }
};
// TODO: better define the generic types
var I18n = /** @class */ (function () {
    function I18n(language, messages, cldrRules, options, messagesObj) {
        this.pluralFunc = this.pluralFunc.bind(this);
        this.getMessage = this.getMessage.bind(this);
        this.selectFunc = this.selectFunc.bind(this);
        this.isProd = IS_PROD;
        this.language = '';
        this.messagesObj = {};
        this.cldrFunc = function () { return ''; };
        this.fallbackRenderer =
            (options && options.fallbackRenderer) || defaultFallbackRenderer;
        this.displayTags = (options && options.showTags) || false;
        this.ignoreNotUsingTFnWarning = (options && options.ignoreNotUsingTFnWarning) || false;
        this.onTranslateFn =
            (options && options.onTranslate) || defaultOnTranslateFn;
        if (typeof messages === 'function') {
            this.setLanguage(language, messages, cldrRules);
        }
        else {
            this.setLanguage(language, messages.bundled, cldrRules);
            // In case of a conflict, dynamically added messages can replace a bundled message for the same copytag
            if (messages.dynamic != null) {
                this.addMessages(messages.dynamic);
            }
        }
        this.onTranslateErrorFn =
            (options && options.onTranslateErrorFn) || defaultOnTranslateErrorFn;
        // if we received this - means we were cloning store
        if (messagesObj) {
            this.messagesObj = messagesObj;
        }
    }
    // TODO remove this method in the next major release, in favor of getLanguage
    I18n.prototype.currentLanguage = function () {
        return this.language;
    };
    I18n.prototype.setLanguage = function (language, messages, plural) {
        this.cldrFunc = plural;
        this.language = language;
        this.messagesObj = {};
        this.addMessages(messages);
    };
    I18n.prototype.addMessages = function (messages) {
        this.messagesObj = __assign(__assign({}, this.messagesObj), messages(this.selectFunc, this.pluralFunc, this.getArgFunc, this.getMessage));
    };
    // TODO rename this to `setOnTranslate` on the next major release
    I18n.prototype.onTranslate = function (value) {
        this.onTranslateFn = value;
    };
    I18n.prototype.trans = function (message) {
        var copyTag = message.tag, _a = message.args, num_exception = _a.num_exception, variables = _a.variables;
        var tag = this.onTranslateFn(copyTag, variables);
        if (!this.messagesObj) {
            throw new RuntimeError(ErrorCodes.MissingTag, tag);
        }
        if (this.showTags()) {
            return tag;
        }
        if (process.env.NODE_ENV !== 'production' &&
            !isTranslationMessage(message) && !this.ignoreNotUsingTFnWarning) {
            console.warn(getErrorMessage(ErrorCodes.NotUsingTFunction, [tag]));
        }
        var translatedMessage;
        try {
            translatedMessage = this.getMessage(tag)(__assign({ num_exception: num_exception }, variables));
        }
        catch (err) {
            var error = err;
            var extra = error.args ? __spreadArray([], __read(error.args), false) : [];
            var code = error.code ? error.code : error.message;
            this.onTranslateErrorFn(getErrorMessage(code, __spreadArray([tag], __read(extra), false)));
            translatedMessage = this.fallbackRenderer(tag);
        }
        return translatedMessage;
    };
    I18n.prototype.clone = function () {
        return new I18n(this.language, function () { return ({}); }, this.cldrFunc, {
            fallbackRenderer: this.fallbackRenderer,
            showTags: this.displayTags,
            onTranslate: this.onTranslateFn,
            onTranslateErrorFn: this.onTranslateErrorFn,
        }, __assign({}, this.messagesObj));
    };
    I18n.prototype.getMessage = function (tag) {
        var msgFunc = this.messagesObj[tag];
        if (!msgFunc) {
            throw new RuntimeError(ErrorCodes.MissingTag, tag);
        }
        return msgFunc;
    };
    I18n.prototype.selectFunc = function (args, obj) {
        var argName = args[String(SELECT_ARG_NAME)];
        if (argName === undefined && !this.isProd) {
            throw new RuntimeError(ErrorCodes.MissingListItemArgument);
        }
        var func = obj[String(argName)];
        if (!func) {
            throw new RuntimeError(ErrorCodes.MissingListItem, argName);
        }
        return func(args);
    };
    I18n.prototype.pluralFunc = function (args, obj) {
        var argName = args[String(PLURAL_ARG_NAME)];
        if (argName === undefined && !this.isProd) {
            throw new RuntimeError(ErrorCodes.MissingNumExceptionArgument);
        }
        var arg = this.cldrFunc(Number(argName), false);
        var func = obj[arg] || obj['other'];
        if (!func) {
            throw new RuntimeError(ErrorCodes.MissingPluralException, arg);
        }
        return func(args);
    };
    I18n.prototype.getArgFunc = function (argName, obj) {
        var arg = obj[String(argName)];
        if (arg === null || typeof arg === 'undefined') {
            throw new RuntimeError(ErrorCodes.MissingVariable, argName);
        }
        return arg;
    };
    I18n.prototype.showTags = function () {
        return this.displayTags;
    };
    I18n.prototype.setShowTags = function (value) {
        this.displayTags = value;
    };
    I18n.prototype.setFallbackRenderer = function (value) {
        this.fallbackRenderer = value;
    };
    I18n.prototype.getLanguage = function () {
        return this.language;
    };
    // TODO rename this to `setOnTranslateError` on the next major release
    I18n.prototype.onTranslateError = function (onTranslateErrorFunction) {
        this.onTranslateErrorFn = onTranslateErrorFunction;
    };
    return I18n;
}());

// This is a noop function that will be removed by 'removeRegisterDynamicTagsUsagesPlugin'
// The actual extraction of contents of t() functions is done via @bookingcom/lingojs-plugin-extract-babel
function registerDynamicTags() {
    var _args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        _args[_i] = arguments[_i];
    }
}

export { I18n, registerDynamicTags, parseTransArguments as t };
//# sourceMappingURL=index.es.js.map
